import { Link } from "react-router-dom";
import type { FoodUnpricedIngredient } from "../foodApi";

export function unpricedReason(i: FoodUnpricedIngredient): string {
  if (i.reason === "no_cost") return "no cost yet";
  return `cost is per ${i.costUnit ?? "?"}, recipe uses ${i.recipeUnit}`;
}

/** Links to each ingredient that has no usable cost, with the reason. */
export function UnpricedIngredients({
  items,
  compact = false,
}: {
  items: FoodUnpricedIngredient[] | undefined;
  compact?: boolean;
}) {
  if (!items || items.length === 0) return null;
  return (
    <ul className={compact ? "mt-1 space-y-0.5 text-xs" : "mt-1 list-disc space-y-0.5 pl-5 text-sm"}>
      {items.map((i, idx) => (
        <li key={`${i.ingredientId}-${idx}`}>
          <Link to={`/food/ingredients/${i.ingredientId}`} className="text-amber-300 underline hover:text-amber-200">
            {i.name}
          </Link>
          <span className="text-tribal-muted"> ({unpricedReason(i)})</span>
        </li>
      ))}
    </ul>
  );
}
